import { LOCATION_CHANGE } from "connected-react-router";
import { history } from "./store";
import actions from "./auth/actions";
import { axiosWithoutToken } from "./axiosMiddleware";
import { AnyAction, Store } from "redux";
import { fetchInitialData, get, SERVICES } from "./apis/global";
import {
  OAUTH_CLIENT_ID,
  REDIRECT_URI,
} from "../containers/Pages/SignIn/config";

const loadingMiddleware =
  (store: Store) => (next: any) => async (action: AnyAction) => {
    if (action.type === LOCATION_CHANGE) {
      // console.log("hereee");
      const isFirstRendering = action.payload.isFirstRendering;
      const isUserLoggedIn = localStorage.getItem("isCapitalUserLoggedIn");
      if (isFirstRendering && isUserLoggedIn) {
        const currentRoute = history.location?.pathname;

        try {
          history.replace("/refreshing");
          store.dispatch(actions.refreshing(true));
          const response = await axiosWithoutToken.post("/oauth/token", {
            grant_type: "refresh_token",
            refresh_token: localStorage.getItem("refresh_token"),
            client_id: OAUTH_CLIENT_ID,
            redirect_uri: REDIRECT_URI,
          });
          if (response.data.access_token) {
            localStorage.setItem("isCapitalUserLoggedIn", "true");
            store.dispatch(actions.loginSuccess(response.data.access_token));
            if (
              !process.env.NODE_ENV ||
              process.env.NODE_ENV === "development"
            ) {
              localStorage.setItem(
                "refresh_token",
                response.data.refresh_token
              );
            }
            const user = await get(`${SERVICES.ACCOUNT}/own`);
            if (user) {
              if (user?.verified === 1) {
                store.dispatch(actions.getUser(user));
                fetchInitialData(store.dispatch, user);
                history.replace(currentRoute);
              } else {
                history.replace("/confirm-account");
              }
            } else {
              refreshCatch(store);
            }
          } else {
            refreshCatch(store);
          }
        } catch (e) {
          refreshCatch(store);
        }
      }
    }
    // pass onto next middleware
    return next(action);
  };

const refreshCatch = (store: Store) => {
  history.replace("/signin");
  store.dispatch(actions.refreshing(false));
  localStorage.removeItem("isCapitalUserLoggedIn");
};

export default loadingMiddleware;
